/**
 * payDataInvoiceApi — RTK Query slice cho /purchase/pay-data-invoice/*.
 *
 * File RIÊNG (không sửa payDataApi.ts dùng chung). injectEndpoints trên baseApi,
 * reuse tag 'PayData' để invalidate list sau khi gán invoice.
 *
 * Backend: app/api/v1/endpoints/purchase/pay_data_invoice.py
 *   GET  /purchase/pay-data-invoice/list?contract_no=&paydata_ids=
 *   POST /purchase/pay-data-invoice/attach
 */
import { baseApi } from './baseApi'

/** Một dòng invoice của contract (đọc public.v_invoice_p). */
export interface PayDataInvoiceItem {
  invoice_id: number
  invoice_no: string | null
  contract_no: string | null
  invoice_date: string | null
  warehouse: string | null
  quantity: number | null
  price_vnd_kg: number | null
  quality_code: string | null
  certification: string | null
  license_cert_no: string | null
  total_payment: number | null
  total_amount: number | null
  vat_amount: number | null
  total_amount_after_tax: number | null
  note: string | null
  date_update: string | null
  person_update: string | null
}

/** Tóm tắt paydata cha (DSum theo ticked rows). */
export interface PayDataInvoiceSummary {
  contract_no: string | null
  supplier: string | null
  price_unit: string | null
  contract_type: string | null
  quantity: number
  requested_usd: number
  requested_vnd: number
  advanced: number
}

export interface PayDataInvoiceListResponse {
  summary: PayDataInvoiceSummary
  items: PayDataInvoiceItem[]
  total: number
}

/** Một dòng paydata đã tick + giá trị edit (mirror Access subFormEdit). */
export interface AttachInvoiceRow {
  paydata_p_id: number
  invoice_no: string | null
  paid_usd: number | null
  fx: number | null
  vat_amount_vnd: number | null
  paid_vnd: number | null
}

export interface AttachInvoiceRequest {
  contract_no: string
  rows: AttachInvoiceRow[]
}

export interface AttachInvoiceResult {
  updated: number
}

interface AttachInvoiceResponse {
  data: AttachInvoiceResult
  message: string
}

export const payDataInvoiceApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    listPayDataInvoices: b.query<
      PayDataInvoiceListResponse,
      { contractNo: string; paydataIds: number[] }
    >({
      query: ({ contractNo, paydataIds }) => {
        // FastAPI `list[int]` cần REPEATED params (paydata_ids=1&paydata_ids=2),
        // KHÔNG phải CSV — fetchBaseQuery mặc định flatten array thành CSV → 422.
        const sp = new URLSearchParams()
        sp.set('contract_no', contractNo)
        for (const id of paydataIds) sp.append('paydata_ids', String(id))
        return { url: `/purchase/pay-data-invoice/list?${sp.toString()}` }
      },
      providesTags: [{ type: 'PayData' as const, id: 'INVOICE_LIST' }],
    }),
    attachPayDataInvoice: b.mutation<AttachInvoiceResponse, AttachInvoiceRequest>({
      query: (body) => ({
        url: '/purchase/pay-data-invoice/attach',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'PayData' as const, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
})

export const { useListPayDataInvoicesQuery, useAttachPayDataInvoiceMutation } =
  payDataInvoiceApi
